import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, Files, API, Utility, Button, Control } from 'helpers/PrintImports';
import { Document } from 'models/DocumentModel';

const DocumentPrint: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.DOCUMENT, Code.Form.Name.DOCUMENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);

  useEffect(() => {
    API.Data.GetByKeyId<Document>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        if (data.document_file_name) {
          const url = await Files.File.Fetch(data.document_file_name,"document");
          setFileUrl(url);
        }
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Button.PrintDocument keyId={keyId} fileUrl={fileUrl} formName={formName} Privilege={Privilege} fileName='order' printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
          <Field.Document fileUrl={fileUrl} />
        </Control.Print.Data>    
      </>)}
    {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
    <Actions.Print />
    </Control.Print.Frame>
  );
};

export default DocumentPrint;